import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import SurveyPageModal from './SurveyPageModal.js';

import {SurveyComponentsByType} from './SurveyContainer.js';
import SurveyPageUnknown                    from './types/SurveyPageUnknown.js';

class SurveyPageModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy:false};
        this.onSubmit = this.onSubmit.bind(this);
    }
    onSubmit(event, userChallenge, savedState) {
        event && event.preventDefault();

        if(userChallenge) {
            this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:true});
            this.setState({busy:true});
            DatabaseService.completeSurvey(this.props.surveyPage.surveyId, [userChallenge])
                .then((result)=>{
                    this.props.onCompleted();
                })
                .catch((error)=>{
                    console.error('SurveyContainer.onNextStep - error ', error);
                })
                .then(()=>{
                    this.props.dispatch({type:"SET_LOADING_OVERLAY_ENABLE", enable:false});
                    this.setState({busy:false});
                });
        }

    }
    getSurveyComponentByType(type) {
        return SurveyComponentsByType.hasOwnProperty(type) ? SurveyComponentsByType[type] : SurveyPageUnknown;
    }
    render() {
        var surveyPage = this.props.surveyPage;
        if(surveyPage) {
            var SurveyPageComponent = this.getSurveyComponentByType(surveyPage.type);
            return (
                <SurveyPageModal surveyPage={this.props.surveyPage}
                                 onClose={this.props.onClose}>
                    <SurveyPageComponent surveyPage={this.props.surveyPage}
                                     onSubmit={this.onSubmit}
                                     inlineButtons />
                </SurveyPageModal>
                );
        }
        return null;
    }

}

export default connect()(SurveyPageModalContainer);



// WEBPACK FOOTER //
// ./src/modules/surveys/SurveyPageModalContainer.js